import ExpirationTypeModel     from '@models/shop/ExpirationTypeModel';
import ProductGroupStatusModel from '@models/shop/ProductGroupStatusModel';
import ProductTypeModel        from '@models/shop/ProductTypeModel';
import VatModel                from '@models/shop/VatModel';
import doc                     from '@widesk-core/decorators/doc';
import model                   from '@widesk-core/decorators/model';
import ShopServiceModel        from '@/models/ShopServiceModel';
import TimestampAble           from '@widesk-core/models/traits/TimestampAble';
import Blamable                from '@/models/traits/Blamable';

@model.urnResource('product_group')
@doc.path('/product_groups/{?id}')
export default class ProductGroupModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'productGroupStatus': id;
		'productGroupStatus.reference': Shop_ProductGroupStatusReference;
		'productType': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
		'vat': id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};

	@doc.number declare bankDelay: number;
	@doc.model(ExpirationTypeModel) declare expirationType: ExpirationTypeModel;
	@doc.string declare label: string;
	@doc.boolean declare manualValidation: boolean;
	@doc.number declare maxQuantityPerOrder: number;
	@doc.model(ProductGroupStatusModel) declare productGroupStatus: ProductGroupStatusModel;
	@doc.model(ProductTypeModel) declare productType: ProductTypeModel;
	@doc.model(VatModel) declare vat: VatModel;
}